// Wallet utility functions for better MetaMask integration
export const checkMetaMaskAvailability = () => {
  if (typeof window === 'undefined') {
    return { available: false, error: 'Window object not available' };
  }

  if (!window.ethereum) {
    return { available: false, error: 'MetaMask not installed' };
  }

  // Check if it's actually MetaMask (not other wallet providers)
  if (!window.ethereum.isMetaMask) {
    return { available: false, error: 'MetaMask not detected' };
  }

  return { available: true, error: null };
};

export const checkHTTPS = () => {
  if (typeof location === 'undefined') {
    return { isHTTPS: false, error: 'Location not available' };
  }

  const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
  const isHTTPS = location.protocol === 'https:';
  
  if (!isHTTPS && !isLocalhost) {
    return { isHTTPS: false, error: 'HTTPS required for MetaMask in production' };
  }

  return { isHTTPS: true, error: null };
};

export const getWalletConnectionError = (error) => {
  if (!error) return 'Unknown error occurred';

  // MetaMask specific error codes
  switch (error.code) {
    case 4001:
      return 'User rejected the request';
    case -32002:
      return 'Request already pending in MetaMask';
    case -32603:
      return 'Internal JSON-RPC error';
    case -32601:
      return 'Method not found';
    case -32700:
      return 'Parse error';
    default:
      break;
  }

  // Check error messages
  if (error.message) {
    if (error.message.includes('User rejected') || error.message.includes('User denied')) {
      return 'User rejected the connection request';
    }
    if (error.message.includes('wallet_requestPermissions')) {
      return 'Permission request already pending';
    }
    if (error.message.includes('Non-Error promise rejection')) {
      return 'MetaMask connection failed - please refresh and try again';
    }
    if (error.message.includes('Already processing')) {
      return 'MetaMask is processing another request - please wait';
    }
    if (error.message.includes('Unauthorized')) {
      return 'Unauthorized access - please check MetaMask permissions';
    }
  }

  return error.message || 'Unknown wallet connection error';
};

export const waitForMetaMask = (timeout = 5000) => {
  return new Promise((resolve, reject) => {
    if (window.ethereum) {
      resolve(window.ethereum);
      return;
    }

    const timer = setTimeout(() => {
      reject(new Error('MetaMask not detected within timeout'));
    }, timeout);

    const checkForMetaMask = () => {
      if (window.ethereum) {
        clearTimeout(timer);
        resolve(window.ethereum);
      } else {
        setTimeout(checkForMetaMask, 100);
      }
    };

    checkForMetaMask();
  });
};

export const isWalletConnected = async () => {
  try {
    if (!window.ethereum) return false;
    
    const accounts = await window.ethereum.request({ method: 'eth_accounts' });
    return accounts && accounts.length > 0;
  } catch (error) {
    console.error('Error checking wallet connection:', error);
    return false;
  }
};

export const getCurrentAccount = async () => {
  try {
    if (!window.ethereum) return null;
    
    const accounts = await window.ethereum.request({ method: 'eth_accounts' });
    return accounts && accounts.length > 0 ? accounts[0] : null;
  } catch (error) {
    console.error('Error getting current account:', error);
    return null;
  }
};
